var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Map',{staticClass:"animated fadeIn",attrs:{"gestureHandling":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }